const APP_TITLE = 'OverWheels';

export function setPageTitle() {
	let pageTitle = '';
	const args = arguments;
	for (let i = 0; i < args.length; ++i) {
		pageTitle += args[i] + ' | ';
	}
	document.title = pageTitle += APP_TITLE;
}